(() => {
  if (window.__HPS_HORIZON_PRODUCT_GRID_V9__) return;
  window.__HPS_HORIZON_PRODUCT_GRID_V9__ = true;

  const normalise = (value) => String(value || '').trim().toLowerCase();

  const findVariantMap = (card, value) => {
    const wanted = normalise(value);
    if (!wanted) return null;

    return Array.from(card.querySelectorAll('[data-hps-native-value]')).find((map) => {
      return normalise(map.dataset.hpsNativeValue) === wanted;
    }) || null;
  };

  const mapForSwatch = (card, swatch) => {
    if (!card || !swatch) return null;
    return findVariantMap(card, swatch.getAttribute('title'));
  };

  const syncVariant = (card, map, resetQuantity = true) => {
    if (!card || !map || !map.dataset.variantId) return;

    const form = card.querySelector('.hps-horizon-card__form form');
    const variantInput = form ? form.querySelector('input[name="id"]') : null;

    if (variantInput) {
      variantInput.value = map.dataset.variantId;
      variantInput.setAttribute('value', map.dataset.variantId);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    card.dataset.hpsSelectedVariant = map.dataset.variantId;

    const sku = card.querySelector('.hps-horizon-card__sku');
    if (sku) sku.textContent = map.dataset.variantSku || '\u00a0';

    const price = card.querySelector('.hps-horizon-card__price');
    if (price && map.dataset.variantPrice) {
      let priceHtml = `<span class="hps-horizon-card__price-current">${map.dataset.variantPrice}</span>`;
      if (map.dataset.variantHasCompare === 'true' && map.dataset.variantCompare) {
        priceHtml += `<s class="hps-horizon-card__price-compare">${map.dataset.variantCompare}</s>`;
      }
      price.innerHTML = priceHtml;
    }

    if (map.dataset.variantUrl) {
      card.querySelectorAll('.hps-horizon-card__image, .hps-horizon-card__title').forEach((link) => {
        link.href = map.dataset.variantUrl;
      });
    }

    const available = map.dataset.variantAvailable === 'true';
    const atc = card.querySelector('[data-hps-atc]');
    const atcText = card.querySelector('[data-hps-atc-text]');

    if (atc) atc.disabled = !available;
    if (atcText) atcText.textContent = available ? 'Add to cart' : 'Sold out';

    const qtyInput = form ? form.querySelector('[data-hps-qty-input]') : null;
    if (qtyInput) {
      const min = map.dataset.qtyMin || '1';
      const step = map.dataset.qtyStep || '1';

      qtyInput.min = min;
      qtyInput.step = step;

      if (map.dataset.qtyMax) qtyInput.max = map.dataset.qtyMax;
      else qtyInput.removeAttribute('max');

      if (resetQuantity) {
        qtyInput.value = min;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.hps-horizon-card .grid-swatches .color-swatch');

    if (swatch) {
      const card = swatch.closest('.hps-horizon-card');
      const map = mapForSwatch(card, swatch);

      if (map) {
        card.querySelectorAll('.grid-swatches .color-swatch').forEach((item) => {
          item.classList.toggle('active', item === swatch);
          item.classList.toggle('is-active', item === swatch);
          item.setAttribute('aria-pressed', String(item === swatch));
        });
        syncVariant(card, map, true);
      }
      return;
    }

    const qtyButton = event.target.closest('.hps-horizon-card__qty-btn');
    if (!qtyButton) return;

    // Avone's native QuantityInput handles this when it is registered.
    // This fallback only runs if the native custom element is unavailable.
    if (window.customElements && customElements.get('quantity-input')) return;

    const quantity = qtyButton.closest('[data-hps-qty]');
    const input = quantity ? quantity.querySelector('[data-hps-qty-input]') : null;
    if (!input) return;

    event.preventDefault();

    const oldValue = input.value;
    if (qtyButton.name === 'plus') input.stepUp();
    else input.stepDown();

    if (oldValue !== input.value) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);

  // Capture submit before Avone's ProductForm builds FormData. This guarantees
  // the variant ID in the form matches the currently selected Avone swatch.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const card = form.closest('.hps-horizon-card');
    if (!card || !form.closest('.hps-horizon-card__form')) return;

    const activeSwatch = card.querySelector('.grid-swatches .color-swatch.active');
    const map = mapForSwatch(card, activeSwatch);

    if (map) {
      syncVariant(card, map, false);
      return;
    }

    if (card.dataset.hpsSelectedVariant) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = card.dataset.hpsSelectedVariant;
        variantInput.setAttribute('value', card.dataset.hpsSelectedVariant);
      }
    }
  }, true);

  const initialise = (root) => {
    const cards = root.matches?.('.hps-horizon-card') ? [root] : Array.from(root.querySelectorAll?.('.hps-horizon-card') || []);
    cards.forEach((card) => {
      if (card.dataset.hpsInitialised) return;
      card.dataset.hpsInitialised = 'true';
      const variantInput = card.querySelector('input[name="id"]');
      if (variantInput) card.dataset.hpsSelectedVariant = variantInput.value;
      card.querySelectorAll('.grid-swatches .color-swatch').forEach((swatch) => {
        const map = mapForSwatch(card, swatch);
        const selected = !!map && map.dataset.variantId === variantInput?.value;
        swatch.setAttribute('role', 'button');
        swatch.setAttribute('tabindex', '0');
        swatch.setAttribute('aria-label', swatch.title);
        swatch.setAttribute('aria-pressed', String(selected));
        swatch.classList.toggle('active', selected);
        swatch.classList.toggle('is-active', selected);
      });
    });
  };
  document.addEventListener('keydown', (event) => {
    if (!['Enter', ' '].includes(event.key)) return;
    const swatch = event.target.closest('.hps-horizon-card .color-swatch');
    if (!swatch) return;
    event.preventDefault();
    swatch.click();
  });
  document.addEventListener('change', (event) => {
    const input = event.target.closest('.hps-horizon-card input[name="quantity"]');
    if (!input) return;
    const min = Number(input.min) || 1;
    const step = Number(input.step) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    const value = Number(input.value);
    input.value = String(Math.min(max, min + Math.max(0, Math.floor(((Number.isFinite(value) ? value : min) - min) / step)) * step));
  }, true);
  initialise(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) initialise(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
